import React from "react";

function ImageViewer({ src, altText }) {
  return <img src={src} alt={altText} style={{ maxWidth: "50%", height: "auto" }} />;
}

export default ImageViewer;
